import { render, staticRenderFns } from "./health-integral.vue?vue&type=template&id=32491d47&scoped=true&"
import script from "./health-integral.vue?vue&type=script&lang=js&"
export * from "./health-integral.vue?vue&type=script&lang=js&"
import style0 from "./health-integral.vue?vue&type=style&index=0&id=32491d47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32491d47",
  null
  
)

export default component.exports